/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable default-case */
// import Log from "../core/logging";
// import parseOptions from "../core/base";

import UI from '../core/ui'

import Dispatcher, {
  // Dispatcher,
  Stream
} from '../core/dispatcher-flyd'

import {
  getKey
} from '../core/utilities'

import {
  modelChanged
  // getKey
} from './common'

import {
  makeType,
  parseOptions,
  initLog
} from '../core/base'

import {
  maybe,
  guard,
  getWith
} from '../core/functions'

import {
  listPanels,
  getPanels,
  // initializeControls,
  centerPanel,
  movePanel,
  // scroll,
  // scrollRight,
  // scrollLeft,
  showNextSlide,
  autoPlay,
  stopAutoPlay,
  resetAutoPlay
} from './slideshow-common'

const proto = {
  name: 'Gallery',
  // panels: null,
  controls: null,
  selected: 0,
  timer: null,
  hiddenControls: false,
  controlTimeout: null,

  parseOptions,
  initLog,

  listPanels,
  getPanels,
  // initializeControls,

  centerPanel,
  movePanel,
  // scroll,
  // scrollRight,
  // scrollLeft,
  showNextSlide,
  autoPlay,
  stopAutoPlay,
  resetAutoPlay,

  disabled: false,

  defaultOptions: {
    transition: '0.3s ease-out',
    hideControls: true,
    scrollOnClick: false,
    // "panelRole": "slideshow-slide",
    panelRole: 'gallery-panel',
    minSwipeAmount: 60,
    extraHeight: 60,
    // "duration": "1.2",
    duration: '.6',
    timing: 'ease-in-out',
    preventTouchMove: true,
    interval: 6000,
    usekeys: false,
    autoplay: false
  },

  disable() {
    this.disabled = true
  },

  enable() {
    this.disabled = false
  },

  init() {
    return {
      // npanels: 0,
      // totalPanels: 0,
      initialized: false,
      current: -1,
      next: 0,
      loadedImages: 0,
      sized: false,
      touch: {
        start: {},
        swiped: false
      }
      // // swiped: false,
    }
  },

  update(msg, model) {
    this.log.info('update called:', msg.type, model)

    switch (msg.type) {
    case 'load':
      if (msg.target.tagName === 'IMG') {
        model.loadedImages++
      }
      break
    case 'popup-enabled': {
      // fix
      // const dom = msg.record;
      const found = false
      // const n = this.dom;

      if (!found) {
        this.disable()
      }
      break
    }
    case 'popup-disabled':
      // fix
      this.enable()
      break

    case 'gallery-showslide':
      this.log.info('msg:', {
        ...msg
      })

      if (msg.target === this.dom) {
        model.next = 0
        if (msg.number) {
          // this.log.warn(`gallery-showslide: matching number: ${msg.number}`)
          model.next = msg.number
        }
        if (msg.path) {
          // this.log.warn(`gallery-showslide: matching path: ${msg.path}`)
          const panels = this.listPanels()
          const matches = panels
            .filter(p => p.dataset.path === msg.path)
            .map(p => panels.indexOf(p))

          if (matches.length > 0) {
            model.next = matches[0]
          }
        }
      }
      break

      // browser events
    case 'click':
      if (msg.target.nodeName === document) {
        model.next += 1
      }

      if (msg.target.hasRole('slideshow-nav-next')) {
        // this.log.info('scroll to next')
        model.next += 1
      }
      if (msg.target.hasRole('slideshow-nav-previous')) {
        // this.log.info('scroll to previous')
        model.next -= 1
      }

      break

    case 'keydown':
      if (msg.control || msg.shift) {
        break
      }
      if (!this.dom.isInViewport()) {
        break
      }

      // eslint-disable-next-line default-case
      switch (getKey(msg)) {
      case 'right':
        model.next += 1
        break
      case 'left':
        model.next -= 1
        break
      }
      break

    case 'touchstart':
      this.log.info('touchstart:', {
        ...model
      })
      model.touch.start = {
        x: msg.touches[0].pageX,
        y: msg.touches[0].pageY
      }

      break
    case 'touchmove':
      // msg.preventDefault();
      model.touch.swiped = true
      break
    case 'touchend':
      this.log.info('touchend:', {
        ...model
      })
      // if (model.touch.swiped === true) {
      //     const start = model.touch.start

      //     if (start.x) {
      //         let amount = msg.changedTouches[0].pageX - start.x
      //         amount = Math.abs(amount)

      //         this.log.info(`touch amount: ${amount}`)

      //         if (amount < this.options.minSwipeAmount) {
      //             // don't like this return in the middle of the switch
      //             this.log.info("aborting touchend: returning model")
      //             return model
      //         }

      //         if (start.x < msg.changedTouches[0].pageX) {
      //             model.next -= 1
      //         } else {
      //             model.next += 1
      //         }
      //     } else {
      //         this.log.info("no start.x?")
      //     }
      // }
      // model.touch.swiped = false
      // model.touch.start = {}

      if (model.touch.swiped === true) {
        const swiped = (minSwipeAmount, current_x, start_x) => {
          const amount = Math.abs(current_x - start_x)
          return amount >= minSwipeAmount
        }

        maybe(start_x => {
          if (
            swiped(
              this.options.minSwipeAmount,
              msg.changedTouches[0].pageX,
              start_x
            )
          ) {
            if (start_x < msg.changedTouches[0].pageX) {
              model.next -= 1
            } else {
              model.next += 1
            }
            model.touch.swiped = false
            model.touch.start = {}
          }
        })(getWith('touch', 'start', 'x')(model))
      }
      break
    }

    this.log.info('update returning model:', {
      ...model
    })
    return model
  },

  view(model) {
    const images = [ ...this.dom.getElementsByTagName('img') ]
    if (model.loadedImages > 0) {
      if (model.sized === false) {
        this.setGalleryHeight()
        model.sized = true
      } else if (model.loadedImages < images.length) {
        this.setGalleryHeight()
        model.sized = true
        model.loadedImages = images.length
      }
    } else {
      const loaded = images.filter(i => i.complete).length

      if (loaded > 0) {
        model.loadedImages = loaded
        this.setGalleryHeight()
        model.sized = true
      }
    }

    if (model.current !== model.next) {
      const panels = this.listPanels()
      this.log.info('view: panels:', panels.length)

      if (model.next >= panels.length) {
        model.next = 0
      } else if (model.next < 0) {
        model.next = panels.length - 1
      }

      this.log.info('next:', model.next)
      model = this.scroll(model)
      model.current = model.next
    }
    model.initialized = true
    return model
  },

  initialize(slideshow) {
    guard(slideshow)
      .where(slideshow != null)
      .do(slideshow => {
        this.initLog()
        // this.log.enable();

        this.dom = slideshow

        let currentModel = this.init()

        // filter this
        Dispatcher.map(msg => {
          if (msg.target === this.dom) {
            let model = {
              ...currentModel
            }
            model.npanels = this.listPanels().length
            model = this.update(msg, model)

            if (modelChanged(currentModel, model)) {
              model = this.view(model)
            }
            currentModel = model
          }
        })

        this.eventStream = new Stream()
        this.eventStream.map(msg => {
          let model = {
            ...currentModel
          }
          model.npanels = this.listPanels().length
          model = this.update(msg, model)

          if (modelChanged(currentModel, model)) {
            model = this.view(model)
          }
          currentModel = model
        })

        this.parseOptions()

        this.dom.getElements('img').forEach(i => {
          i.addEvent('load', this.eventStream.stream)
        })

        this.dom.addEvent('touchstart', this.eventStream.stream)
        this.dom.addEvent('touchmove', this.eventStream.stream)
        this.dom.addEvent('touchend', this.eventStream.stream)

        if (this.options.usekeys) {
          document.addEventListener(
            'keydown',
            this.eventStream.stream
          )
        }

        currentModel = this.initializePanels(currentModel)

        const panels = this.listPanels()

        setTimeout(() => {
          panels.forEach(p => {
            p.removeClass('loading')
          })
        }, 500)

        // this.log.info("autoplay?", this.options.autoplay);

        if (this.options.autoplay === true) {
          this.autoPlay()
        } else {
          const c = this.dom.getElementsByRole(
            'slideshow-nav-pause'
          )[0]
          if (c) {
            c.addClass('paused')
          }
        }

        if (this.options.scrollOnClick === true) {
          this.dom.addEvent('click', this.eventStream.stream)
        }

        // this.scrollTo();
        currentModel = this.view(currentModel)
      })
  },

  scrollToTop() {
    // this.log.warn(`scroll?`, this.dom.dataset.scroll)
    // const section = this.dom.closestByRole("page-section")
    guard(this.dom.closestByRole('page-section'))
      .where(
        section => getWith('dataset', 'scroll')(section) === 'true'
      )
      .do(section => {
        // this.log.warn (`scrollToTop: guard passed:`, section)

        let offset = 0;
        [ ...document.getElementById('navigation').children ].forEach(
          c => {
            offset += c.offsetHeight
          }
        )

        const target = section.offsetTop - (offset + 100)
        if (target > 300) {
          window.scrollTo(0, target)
          window.onbeforeunload = function () {
            window.scrollTo(0, target)
          }
        }
      })
  },

  findSelectedPanel(model) {
    const panels = this.listPanels()
    const path = window.location.pathname

    // this.log.warn (`findSelectedPanels: selected: ${path}`)

    // let start = guard(window.location.pathname)
    // .where(path != null)
    // .do(path => {

    // })

    let start = 0
    if (path) {
      // panels.map (p =>
      //     this.log.warn (
      //         `path: '${p.dataset.path}' === '${path}'`,
      //         p.dataset.path === path,
      //         typeof p.dataset.path,
      //         typeof path

      //     )
      // )

      start = panels
        .filter(p => p.dataset.path != null)
        .filter(p => p.dataset.path.trim() === path.trim())
        .map(p => panels.indexOf(p))
        .shift()
      start = start === undefined ? 0 : start
    }

    // this.log.warn (`selected index: ${start}`)

    if (start < panels.length) {
      model.next = start
    }

    return model
  },

  initializePanels(model) {
    model = {
      ...model
    }
    let height = 0
    const panels = this.listPanels()
    const start = this.findSelectedPanel(model)

    panels.forEach((p, c) => {
      const h = p.getDimensions().y

      if (h > height) {
        height = h
      }
      this.centerPanel(c)
      if (c === start) {
        // not necessary if stylesheet is correct
        p.addClass('slideshow-slide-first')
      }
      // Transform.setDuration(p, this.options.duration);
      // Transform.setTimingFunction(p, this.options.timing);
    })

    if (!this.panelsLoaded) {
      this.getPanels()
      this.panelsLoaded = true
    }

    document.addEvent('DOMContentLoaded', () => {
      this.setGalleryHeight()
    })

    document.addEvent('load', () => {
      this.setGalleryHeight()
    })

    return model
  },

  setGalleryHeight() {
    if (this.options.calculateHeight) {
      const panels = this.dom.findByRole(this.options.panelRole)
      let height = 0

      // const body = document.getElementsByTagName("main")[0];
      // const body = document.getElementById("detailBlock");
      const body = this.dom.parentElement
      panels.forEach(p => {
        const test = p.cloneNode(true)

        test.setStyle('left', -10000)
        test.removeClass('hidden')
        test.setStyle('visibility', 'visible')
        test.setStyle('display', 'block')

        body.appendChild(test)

        const h = test.getDimensions().y

        test.dispose()

        if (h > height) {
          height = h
        }
      })

      height += parseInt(this.options.extraHeight) // set in dataset options

      this.dom.setStyles({
        'min-height': 0,
        height: `${height}px`
      })
    }
  },

  showPanel(p, initialized) {
    p.style.opacity = 1
    p.removeClass('hidden')
    p.addClass('visible')

    if (initialized == true)
      if (p.dataset.path) {
        // eslint-disable-next-line no-undef
        window.history.replaceState({}, '', p.dataset.path)
      }
    else {
      // just not do this?
      if (window.location.hash !== "") {
        window.history.replaceState({}, '', p.dataset.path)
      }

    }
    const panels = this.listPanels()
    this.active = p

    Dispatcher.dispatch({
      type: 'gallery-panelshown',
      target: this.dom,
      number: panels.indexOf(p),
      path: p.dataset.path
    })
  },

  hidePanel(p) {
    // this.log.warn(`hidePanel:`, p)

    p.style.opacity = 0
    p.removeClass('visible')
    p.addClass('hidden')
  },

  scroll(model) {
    model = {
      ...model
    }
    const idx = model.next
    const selected = model.current

    this.log.info('scroll:', idx, 'current:', selected)
    if (this.disabled) {
      this.log.info('gallery disabled')
      return model
    }

    const panels = this.listPanels()
    panels.forEach(p => this.hidePanel(p))
    if (Number.isInteger(idx)) {
      if (panels[idx]) {
        this.showPanel(panels[idx], model.initialized)
      }

      if (this.timer) {
        this.resetAutoPlay()
      }
    } else {
      this.log.info('scroll: idx isn\'t integer:', idx)
    }
    return model
  }
}

export const Gallery = makeType(proto)

UI.register('slideshow-gallery', Gallery)
